export default function reloadAfterPaint(): void {
  if (typeof window.requestAnimationFrame !== 'function') {
    window.location.reload();
    return;
  }
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      window.location.reload();
    });
  });
}
